import {Component} from 'react';
import {connect} from 'react-redux';
import {throttle, uniq} from 'lodash';

import config from '../../../config/config';
import {isMocks} from '../../../utils/utils';
import {PRODUCT_TYPE_ENUM_MAP} from "../../../settings/settings";
import {compose} from "redux";

export class SessionTimer extends Component {

  autoLogout() {
    const {
      userProductTypes: { entity },
    } = this.props;
    const {
      hasAPP,
      hasRAS,
      hasBrokerage,
      hasMutualFund,
      hasNAT529,
      hasMD529,
      hasAK529
    } = entity || {};
    const accounts = [];
    if (hasMutualFund) {
      accounts.push({ productType: PRODUCT_TYPE_ENUM_MAP["MUTUAL_FUND"] });
    }
    if (hasAK529) {
      accounts.push({ productType: PRODUCT_TYPE_ENUM_MAP["ALASKA_529"] });
    }
    if (hasNAT529) {
      accounts.push({ productType: PRODUCT_TYPE_ENUM_MAP["NATIONAL_529"] });
    }
    if (hasMD529) {
      accounts.push({ productType: PRODUCT_TYPE_ENUM_MAP["MARYLAND_529"] });
    }
    if (hasBrokerage) {
      accounts.push({ productType: PRODUCT_TYPE_ENUM_MAP["BROKERAGE"] });
    }
    if (hasAPP) {
      accounts.push({ productType: PRODUCT_TYPE_ENUM_MAP["MANAGED_ACCOUNT"] });
    }
    if (hasRAS) {
      accounts.push({ productType: PRODUCT_TYPE_ENUM_MAP["RETIREMENT_ADVISORY"] });
    }
    const products = uniq(accounts.map((a) => a.productType));
    window.location.href = `${config.url}/usis/login/logout?sdurl=https://www.troweprice.com/usis/my-accounts/post-logout?productTypes=${products}`;
  }

  constructor(props) {
    super(props);
    this.restartSessionTimer = throttle(this.restartSessionTimer, 5000);
    this.autoLogout = this.autoLogout.bind(this);
  }

  componentDidMount() {
    if (isMocks()) {
      // return;
    }

    this.restartSessionTimer();
    const body = document.getElementsByTagName('body')[0];
    body.addEventListener('mousemove', this.restartSessionTimer, true);
    body.addEventListener('keypress', this.restartSessionTimer, true);
  }

  componentWillUnmount() {
    const body = document.getElementsByTagName('body')[0];
    body.removeEventListener('mousemove', this.restartSessionTimer);
    body.removeEventListener('keypress', this.restartSessionTimer);
  }

  restartSessionTimer() {
    const logoutMilliseconds = 1500000;

    if (this.sessionTimerId) {
      clearTimeout(this.sessionTimerId);
    }
    this.sessionTimerId = setTimeout(this.autoLogout, logoutMilliseconds);
  }

  render() {
    // We have no UI right now but still using React component pattern because
    // we will have a UI with a warning pop up in the future and component
    // provides easier integration with app
    return null;
  }
}

const mapStateToProps = (state) => {
  const { userProductTypes } = state;
  return { userProductTypes };
};

export default compose(connect(mapStateToProps))(SessionTimer);
